import { useColorMode } from '@/composables/useColorMode'

export enum eTheme {
  CS = 'cs',
  WS = 'ws',
  IM = 'im',
  FU = 'fu',
}

export const theme = (): eTheme => {
  const regex1 = new RegExp('.*citysys.*')
  const regex2 = new RegExp('.*worksys.*')
  const regex3 = new RegExp('.*iomobility.*')

  if (regex1.exec(window.location.host)) {
    return eTheme.CS
  }

  if (regex2.exec(window.location.host)) {
    return eTheme.WS
  }

  if (regex3.exec(window.location.host)) {
    return eTheme.IM
  }

  return eTheme.FU
}

export const themeInit = () => {
  useColorMode()
  document.body.classList.add(
    {
      [eTheme.CS]: 'theme-cs',
      [eTheme.WS]: 'theme-ws',
      [eTheme.IM]: 'theme-im',
      [eTheme.FU]: 'theme-fu',
    }[theme()],
  )

  if (theme() === eTheme.CS) {
    let link =
      (document.querySelector("link[sizes='16x16']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = './img/icons/cs-favicon-16x16.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector("link[sizes='32x32']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = './img/icons/cs-favicon-32x32.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector("link[sizes='180x180']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'apple-touch-icon'
    link.href = './img/icons/cs-apple-icon-180x180.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector('link[rel=manifest]') as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'manifest'
    link.href = './img/icons/cs-manifest.json'
    document.getElementsByTagName('head')[0].appendChild(link)
  } else if (theme() === eTheme.WS) {
    let link =
      (document.querySelector("link[sizes='16x16']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = './img/icons/ws-favicon-16x16.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector("link[sizes='32x32']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = './img/icons/ws-favicon-32x32.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector("link[sizes='180x180']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'apple-touch-icon'
    link.href = './img/icons/ws-apple-touch-icon.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector('link[rel=manifest]') as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'manifest'
    link.href = './img/icons/ws-site.webmanifest'
    document.getElementsByTagName('head')[0].appendChild(link)
  } else if (theme() === eTheme.IM) {
    let link =
      (document.querySelector("link[sizes='16x16']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = './img/icons/im-favicon-16x16.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector("link[sizes='32x32']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = './img/icons/im-favicon-32x32.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector("link[sizes='180x180']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'apple-touch-icon'
    link.href = './img/icons/im-apple-touch-icon.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector('link[rel=manifest]') as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'manifest'
    link.href = './img/icons/im-site.webmanifest'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector('link[rel=mask-icon]') as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'mask-icon'
    link.href = './img/icons/im-safari-pinned-tab.svg'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector('link[rel="shortcut icon"]') as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'shortcut icon'
    link.href = './img/icons/im-favicon.ico'
    document.getElementsByTagName('head')[0].appendChild(link)
  } else {
    let link =
      (document.querySelector("link[sizes='16x16']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = './img/icons/fu-favicon-16x16.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector("link[sizes='32x32']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = './img/icons/fu-favicon-32x32.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector("link[sizes='180x180']") as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'apple-touch-icon'
    link.href = './img/icons/fu-apple-touch-icon.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector('link[rel=manifest]') as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'manifest'
    link.href = './img/icons/fu-site.webmanifest'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector('link[rel=mask-icon]') as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'mask-icon'
    link.href = './img/icons/fu-safari-pinned-tab.svg'
    document.getElementsByTagName('head')[0].appendChild(link)

    link =
      (document.querySelector('link[rel="shortcut icon"]') as HTMLLinkElement) ||
      (document.createElement('link') as HTMLLinkElement)
    link.type = 'image/png'
    link.rel = 'shortcut icon'
    link.href = './img/icons/fu-favicon.ico'
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}
